
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoimagicataxi() {



  const cardData =
  {
    keyword: 'Pune to Imagica Taxi',
    heading: 'AB Ghule Cabs: Pune to Imagica Taxi',
    headingDescription: 'AB Ghule Cabs offers reliable and comfortable taxi services for your trip from Pune to Imagica. Whether you are planning a day of fun at Imagica, one of India’s top amusement parks, or need transportation for a group outing, our fleet of well-maintained vehicles ensures a safe and enjoyable ride. We prioritize customer satisfaction and provide timely service to make your travel experience smooth and hassle-free.',

    top: 'Top Places to Visit in Imagica with AB Ghule Cabs',

    "topPlaces": [
  {
    title: "Imagica Theme Park",
    description: "Imagica Theme Park is the heart of Imagica and a world of adventure, fun, and excitement for everyone. Featuring a variety of thrilling rides, action-packed shows, and unique experiences, this theme park brings joy to visitors of all ages. Whether you're looking for high-speed roller coasters, fun family-friendly attractions, or immersive themed zones, Imagica has it all. The park’s vibrant atmosphere and diverse attractions make it a must-visit destination for thrill-seekers and families alike."
  },
  {
    title: "Imagica Water Park",
    description: "The Imagica Water Park is the perfect place to cool off and have fun in the sun. Featuring a variety of water slides, wave pools, and lazy rivers, this water park is designed to provide hours of enjoyment for guests of all ages. From adrenaline-pumping slides like the Twister and the Raft Ride to relaxing options like the Lazy River and Splash Pads, the water park offers something for everyone. It’s an ideal destination for families and groups to enjoy a day of refreshing fun."
  },
  {
    title: "Mr. India Ride",
    description: "The Mr. India Ride is a 4D adventure that immerses you in the world of the popular Bollywood movie. This ride takes you on a thrilling journey through Mr. India’s secret lair, where you’ll experience action-packed sequences with special effects, motion seats, and amazing visuals. As you join Mr. India in his fight against evil, you’ll be taken on a ride full of excitement, laughter, and fun. This iconic attraction is one of the highlights of Imagica and a must-see for fans of the movie and thrill-seekers alike."
  },
  {
    title: "Aladdin Ride",
    description: "The Aladdin Ride at Imagica is a magical dark ride that transports you into the world of the beloved Disney character. Experience Aladdin's adventures as you journey through the streets of Agrabah, encountering magical creatures, flying carpets, and thrilling escapades along the way. The ride combines storytelling, captivating visuals, and stunning special effects to create an enchanting experience that will leave visitors of all ages spellbound. It’s a perfect ride for families and anyone who loves adventure and fantasy."
  },
  {
    title: "Nitro",
    description: "Nitro is one of the tallest and fastest roller coasters in India, offering an adrenaline-pumping experience for thrill-seekers. This high-speed coaster features steep drops, intense twists, and thrilling loops, ensuring that you’re in for an exciting ride from start to finish. As you zoom through the track at breakneck speeds, you’ll feel the rush of excitement and the wind in your hair. Nitro is perfect for those who love fast-paced thrills and is one of the park’s most popular attractions."
  },
  {
    title: "Scream Machine",
    description: "The Scream Machine is a heart-stopping ride that will test your limits with its extreme twists, loops, and high-speed thrills. This roller coaster delivers an intense experience as you’re hurled through a series of loops and sudden drops, sending you screaming with excitement. Designed for adrenaline junkies, the Scream Machine is one of the most thrilling rides at Imagica. If you’re looking for an unforgettable ride full of twists, turns, and thrills, this ride is not to be missed!"
  },
  {
    title: "Alibaba Aur Chalis Chor",
    description: "Alibaba Aur Chalis Chor is a family-friendly ride that brings the classic tale of Alibaba and the Forty Thieves to life. This fun and adventurous dark ride takes you on a journey through the caves of Ali Baba as you encounter treasure, traps, and thieves. The ride’s combination of storytelling, visual effects, and animatronics makes it an engaging and entertaining experience for both children and adults. Perfect for families looking for a gentle yet exciting ride, Alibaba Aur Chalis Chor offers a unique blend of culture and adventure."
  },
  {
    title: "Dinosaur Park",
    description: "Step back in time and explore the prehistoric world at the Dinosaur Park in Imagica. This exciting attraction is home to lifelike, animatronic dinosaurs, which move, roar, and interact with visitors. The Dinosaur Park offers an immersive experience where you can walk among these giant creatures and learn about their history. From the mighty T-Rex to the towering Brachiosaurus, the Dinosaur Park brings the ancient world to life and provides a fascinating educational experience for kids and adults alike."
  },
  {
    title: "IMAGICA Snow Park",
    description: "The IMAGICA Snow Park is the ultimate escape from the heat, offering a winter wonderland experience all year round. Step into a chilly environment filled with real snow, where you can enjoy snowball fights, snow slides, and a cool atmosphere even on the hottest days. Whether you’re building a snowman or sliding down the icy slopes, the Snow Park provides a fun and unique experience for visitors of all ages. It’s a great place for families, groups, and anyone who wants to experience the magic of snow in a warm climate."
  },
  {
    title: "Butterfly Garden",
    description: "The Butterfly Garden at Imagica offers a serene and tranquil experience amidst the colorful beauty of nature. Stroll through this peaceful garden and enjoy the sight of hundreds of vibrant butterflies fluttering around you. The garden is home to a wide variety of butterfly species, and it provides a calm escape from the more thrilling attractions in the park. It’s the perfect place for nature lovers and anyone looking to enjoy a peaceful, picturesque environment surrounded by the beauty of the natural world."
  }
],


  services: [
    {
      "name": "Pune to Imagica Taxi Fare",
      description: "Looking for a taxi from Pune to Imagica? AB Ghule Cabs offers affordable and reliable taxi services with competitive fare rates for your journey to Adlabs Imagica. Get a comfortable ride with professional drivers, ensuring a safe and enjoyable trip."
    },
    {
      "name": "Pune to Imagica Cab Charges",
      description: "The cab charges for a trip from Pune to Imagica depend on the vehicle type and distance. AB Ghule Cabs offers flexible pricing options for taxis, including one-way and round-trip fares, to make your trip hassle-free and budget-friendly."
    },
    {
      "name": "Pune to Imagica Taxi Booking",
      description: "Book your taxi from Pune to Imagica with AB Ghule Cabs online. Our easy-to-use booking system allows you to reserve your ride in advance, ensuring a smooth and punctual journey. Choose from a wide range of vehicles to suit your travel needs."
    },
    {
      "name": "Pune to Imagica Car Rental",
      description: "AB Ghule Cabs offers car rental services for your trip from Pune to Imagica. Whether you need a sedan, SUV, or luxury vehicle, we provide well-maintained cars for a comfortable ride to the theme park. Rent a car with a professional chauffeur for a worry-free experience."
    },
    {
      "name": "Pune to Imagica Chauffeur-Driven Cabs",
      description: "Enjoy a chauffeur-driven taxi from Pune to Imagica with AB Ghule Cabs. Our professional and experienced drivers will take care of your travel needs, ensuring a safe, timely, and comfortable journey to Adlabs Imagica."
    },
    {
      "name": "Pune to Imagica Taxi Rates",
      description: "The taxi rates from Pune to Imagica vary based on the type of vehicle and duration of the trip. AB Ghule Cabs offers competitive and transparent taxi rates, ensuring no hidden charges. Contact us for a customized quote that suits your travel preferences."
    },
    {
      "name": "Pune to Imagica Cab Pricing",
      description: "AB Ghule Cabs provides affordable pricing for cabs from Pune to Imagica, ensuring you get the best value for your money. Our pricing includes driver charges, fuel, and other essentials to make your ride smooth and economical."
    },
    {
      "name": "Pune to Imagica Private Car Hire",
      description: "For those seeking a private and comfortable ride to Imagica, AB Ghule Cabs offers private car hire services. Enjoy the luxury of a private ride with no shared passengers, offering more convenience and personal space for your trip."
    },
    {
      "name": "Pune to Imagica Cab Cost",
      description: "The cost of a cab from Pune to Imagica depends on several factors like the type of car and the route. AB Ghule Cabs ensures affordable cab costs for a high-quality, safe, and comfortable journey. Contact us for an exact fare based on your preferences."
    },
    {
      "name": "Pune to Imagica Taxi Service Charges",
      description: "At AB Ghule Cabs, we offer transparent taxi service charges with no hidden fees. Our service charges include driver fees, fuel, and other applicable costs, so you can enjoy your trip without any unexpected surprises."
    },
    {
      "name": "Pune to Imagica Travel Fare",
      description: "The travel fare from Pune to Imagica is designed to offer flexibility and affordability. Whether you are booking a one-way ride or a round trip, AB Ghule Cabs ensures the best rates for a comfortable, timely, and hassle-free experience."
    },
    {
      "name": "Pune to Imagica Cab",
      description: "Looking for a reliable cab from Pune to Imagica? AB Ghule Cabs offers a fleet of well-maintained cars for a smooth, comfortable ride to the theme park. Our cabs are equipped with all necessary amenities to make your journey enjoyable."
    },
    {
      "name": "Cab from Pune to Imagica",
      description: "Book a cab from Pune to Imagica with AB Ghule Cabs for a reliable and punctual journey. Our experienced drivers ensure you have a stress-free and comfortable ride, whether you're visiting Imagica for a fun day or exploring other attractions in the area."
    },
    {
      "name": "Pune to Adlabs Imagica Cab",
      description: "Planning a trip to Adlabs Imagica from Pune? AB Ghule Cabs provides seamless and comfortable taxi services for your visit to Imagica. With a fleet of well-maintained cars and professional drivers, we make your trip to Imagica hassle-free."
    },
    {
      "name": "Pune to Adlabs Imagica Cab Charges",
      description: "Our cab charges for trips from Pune to Adlabs Imagica are affordable and competitive. AB Ghule Cabs offers flexible pricing options based on the car type, distance, and duration. Get in touch with us for an accurate quote tailored to your needs."
    },
    {
      "name": "Pune to Imagica Cab Fare",
      description: "The cab fare for a ride from Pune to Imagica is calculated based on distance, vehicle type, and other factors. AB Ghule Cabs ensures affordable rates and transparency in pricing, so you can enjoy your trip without any hidden costs."
    },
    {
      "name": "Pune to Imagica Cab Price",
      description: "Book a taxi with AB Ghule Cabs for a comfortable and affordable journey from Pune to Imagica. Our cab prices are designed to be competitive, ensuring you get the best value for your trip to the theme park."
    },
    {
      "name": "Pune to Imagica Taxi",
      description: "Choose AB Ghule Cabs for your taxi ride from Pune to Imagica. Our fleet includes well-maintained vehicles, ensuring a smooth ride for you and your family or friends. Book your taxi today for a fun-filled trip to Imagica."
    },
    {
      "name": "Pune to Imagica Taxi Price",
      description: "The price for a taxi ride from Pune to Imagica depends on the car and distance. AB Ghule Cabs offers competitive pricing with no hidden charges, making sure you get a fair price for a comfortable trip to the theme park."
    },
    {
      "name": "Pune to Imagica Taxi Service",
      description: "Book your Pune to Imagica taxi service with AB Ghule Cabs for a safe, comfortable, and timely ride. Our taxis are driven by experienced and professional drivers who ensure a pleasant journey to Imagica."
    },
    {
      "name": "Taxi Fare from Pune to Imagica",
      description: "The taxi fare for a trip from Pune to Imagica depends on the car type, travel duration, and other factors. AB Ghule Cabs offers competitive taxi fares for a comfortable and smooth ride to Imagica."
    },
    {
      "name": "Pune to Imagica Cab Service",
      description: "AB Ghule Cabs offers reliable and affordable cab services from Pune to Imagica. With a variety of vehicle options and professional drivers, we ensure you have a comfortable, stress-free, and enjoyable journey to the theme park."
    },
    {
      "name": "Pune to Imagica Taxi Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Imagica Taxi. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune to Imagica Taxi Fare", "- Pune to Imagica Cab Charges"],
    ["Pune to Imagica Taxi Booking", "- Pune to Imagica Car Rental"],
    ["Pune to Imagica Chauffeur-Driven Cabs", "- Pune to Imagica Taxi Rates"],
    ["Pune to Imagica Cab Pricing", "- Pune to Imagica Private Car Hire"],
    ["Pune to Imagica Cab Cost", "- Pune to Imagica Taxi Service Charges"],
    ["Pune to Imagica Travel Fare", "- Pune to Imagica Cab"],
    ["Cab from Pune to Imagica", "- Pune to Adlabs Imagica Cab"],
    ["Pune to Adlabs Imagica Cab Charges", "- Pune to Imagica Cab Fare"],
    ["Pune to Imagica Cab Price", "- Pune to Imagica Taxi"],
    ["Pune to Imagica Taxi Price", "- Pune to Imagica Taxi Service"],
    ["Taxi Fare from Pune to Imagica", "- Pune to Imagica Cab Service"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Comfortable and Spacious Rides",
      WhyChoosedescription: "Our taxis are perfect for a comfortable and spacious ride to Imagica from Pune. With ample legroom, plush seating, and air-conditioning, you can enjoy a relaxing journey before you dive into the thrills at Imagica."
    },
    {
      WhyChooseheading: "Reliable and Professional Drivers",
      WhyChoosedescription: "Our drivers are highly trained, experienced, and committed to ensuring your safety and comfort. They are well-acquainted with the best routes to Imagica, ensuring a smooth, timely, and hassle-free journey."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive rates for your Pune to Imagica taxi ride without any hidden charges. Our pricing structure is transparent, ensuring that you know exactly what you are paying for, giving you peace of mind during your trip."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "We maintain our vehicles to the highest standards, ensuring that you travel in a clean, safe, and well-maintained car. Whether you choose a sedan or an SUV, our fleet is designed to make your journey as comfortable as possible."
    },
    {
      WhyChooseheading: "On-Time Pick-Up and Drop",
      WhyChoosedescription: "We understand the importance of timely travel, especially when you're heading to a place like Imagica. Our drivers ensure prompt pick-up and drop-off, allowing you to make the most of your day at the amusement park."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking a taxi for your trip to Imagica is simple with AB Ghule Cabs. You can book online via our website or app, or simply call our customer service for assistance. We make sure the booking process is quick and easy."
    },
    {
      WhyChooseheading: "Flexible Rental Packages",
      WhyChoosedescription: "Whether you want a one-way ride or a round trip, we offer flexible rental packages based on your needs. We can also provide extended services if you need to wait while you enjoy your day at Imagica."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We are available around the clock to cater to your taxi needs. Whether you need an early morning ride or a late-night return, we’re ready to serve you whenever you need us."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How do I book a taxi for Pune to Imagica?',
      answer: 'You can easily book a taxi through our website, mobile app, or by calling our customer service. We offer a quick and hassle-free booking process.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for the Pune to Imagica taxi ride?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars. Choose the one that fits your needs and group size for a comfortable journey to Imagica.',
    },
    {
      id: 'FAQ3',
      question: 'Is the taxi air-conditioned?',
      answer: 'Yes, all our taxis are fully air-conditioned, ensuring a comfortable ride even during hot weather.',
    },
    {
      id: 'FAQ4',
      question: 'How much does it cost for a taxi from Pune to Imagica?',
      answer: 'The cost depends on the type of vehicle you choose, the duration, and any special requests. We offer competitive and transparent pricing with no hidden charges.',
    },
    {
      id: 'FAQ5',
      question: 'Are the drivers experienced and professional?',
      answer: 'Yes, our drivers are experienced, well-trained, and background-checked to ensure your safety and comfort throughout the journey.',
    },
    {
      id: 'FAQ6',
      question: 'Can I book a round-trip taxi from Pune to Imagica?',
      answer: 'Yes, we offer both one-way and round-trip taxi options. Our flexible packages allow you to choose the best option based on your schedule.',
    },
    {
      id: 'FAQ7',
      question: 'How do I make payments for the taxi ride?',
      answer: 'We accept various payment methods, including cash, credit/debit cards, and online payments through our mobile app, providing you with flexibility and convenience.',
    },
    {
      id: 'FAQ8',
      question: 'Are there any extra charges for waiting or detours?',
      answer: 'There may be additional charges for waiting time or detours, depending on your journey. We ensure complete transparency, and any extra charges will be communicated in advance.',
    },
    {
      id: 'FAQ9',
      question: 'What if I need to cancel or modify my booking?',
      answer: 'You can modify or cancel your booking easily through our website or app. Our customer service team is also available for assistance if needed.',
    },
    {
      id: 'FAQ10',
      question: 'How far in advance should I book the taxi?',
      answer: 'It is recommended to book in advance to secure the vehicle of your choice. For peak travel periods or special requests, early booking is advised to avoid last-minute issues.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Rajesh Patel',
      feedback: 'I booked a taxi from Pune to Imagica with AB Ghule Cabs, and it was a wonderful experience. The driver was on time, the car was clean and comfortable, and we reached Imagica without any issues. The trip was smooth, and we had a great time at the park. I would highly recommend this service!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Neha Mehta',
      feedback: 'We took a family trip from Pune to Imagica and rented a taxi from AB Ghule Cabs. The car was spacious, and the driver was very polite and professional. It was a pleasant and stress-free journey. We will definitely use their services for our future trips!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Imagica Taxi | Affordable Cab Services & Taxi Booking</title>
  <meta name="description" content="Taxi from Pune to Imagica. Offering affordable cab services with chauffeur-driven cars for a smooth and comfortable trip to Adlabs Imagica. Book online or call +91 8624029699 for pricing and taxi booking." />
  <meta name="keywords" content="Pune to Imagica Taxi Fare, Pune to Imagica Cab Charges, Pune to Imagica Taxi Booking, Pune to Imagica Car Rental, Pune to Imagica Chauffeur-Driven Cabs, Pune to Imagica Taxi Rates, Pune to Imagica Cab Pricing, Pune to Imagica Private Car Hire, Pune to Imagica Cab Cost, Pune to Imagica Taxi Service Charges, Pune to Imagica Travel Fare, Pune to Imagica Cab, Cab from Pune to Imagica, Pune to Adlabs Imagica Cab, Pune to Adlabs Imagica Cab Charges, Pune to Imagica Cab Fare, Pune to Imagica Cab Price, Pune to Imagica Taxi, Pune to Imagica Taxi Price, Pune to Imagica Taxi Service, Taxi Fare from Pune to Imagica, Pune to Imagica Cab Service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Imagica Taxi | Affordable Cab Services & Taxi Booking" />
  <meta property="og:description" content="Taxi from Pune to Imagica. Offering affordable cab services with chauffeur-driven cars for a smooth and comfortable trip to Adlabs Imagica. Book online or call +91 8624029699 for pricing and taxi booking." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-imagica-taxi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-imagica-taxi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Imagica Taxi",
        description: "Taxi from Pune to Imagica. Offering affordable cab services with chauffeur-driven cars for a smooth and comfortable trip to Adlabs Imagica. Book online or call +91 8624029699 for pricing and taxi booking.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-imagica-taxi",
        "logo": "https://abghulecabs.com/images/pune-to-imagica-taxi.jpg",
        "image": "https://abghulecabs.com/images/pune-to-imagica-taxi.jpg",
        "priceRange": "₹2000 - ₹3500",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-imagica-taxi",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Nisha K"
            },
            "datePublished": "2024-11-05",
            "reviewBody": "Wonderful service! The cab was comfortable and the driver was professional. Our trip to Imagica was a breeze. Highly recommend AB Ghule Cabs!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajiv M"
            },
            "datePublished": "2024-10-28",
            "reviewBody": "Booked a cab for Imagica. The fare was reasonable, and the service was excellent. Very pleased with the ride!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Imagica Taxi Services",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-imagica-taxi"
        },
        "keywords": "Pune to Imagica Taxi Fare, Pune to Imagica Cab Charges, Pune to Imagica Taxi Booking, Pune to Imagica Car Rental, Pune to Imagica Chauffeur-Driven Cabs, Pune to Imagica Taxi Rates, Pune to Imagica Cab Pricing, Pune to Imagica Private Car Hire, Pune to Imagica Cab Cost, Pune to Imagica Taxi Service Charges, Pune to Imagica Travel Fare, Pune to Imagica Cab, Cab from Pune to Imagica, Pune to Adlabs Imagica Cab, Pune to Adlabs Imagica Cab Charges, Pune to Imagica Cab Fare, Pune to Imagica Cab Price, Pune to Imagica Taxi, Pune to Imagica Taxi Price, Pune to Imagica Taxi Service, Taxi Fare from Pune to Imagica, Pune to Imagica Cab Service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/45.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetoimagicataxi;